export const GET_COMPANIES = 'GET_COMPANIES'
export const GET_COMPANIES_SUCCESS = 'GET_COMPANIES_SUCCESS'
export const GET_COMPANIES_FAILED = 'GET_COMPANIES_FAILED'

export const GET_COMPANY = 'GET_COMPANY'
export const GET_COMPANY_SUCCESS = 'GET_COMPANY_SUCCESS'
export const GET_COMPANY_FAILED = 'GET_COMPANY_FAILED'

export const CREATE_COMPANY = 'CREATE_COMPANY'
export const CREATE_COMPANY_SUCCESS = 'CREATE_COMPANY_SUCCESS'
export const CREATE_COMPANY_FAILED = 'CREATE_COMPANY_FAILED'

export const UPDATE_COMPANY = 'UPDATE_COMPANY'
export const UPDATE_COMPANY_SUCCESS = 'UPDATE_COMPANY_SUCCESS'
export const UPDATE_COMPANY_FAILED = 'UPDATE_COMPANY_FAILED'

export const RESET_COMPANY_STATE = 'RESET_COMPANY_STATE'

export const GET_COMPANY_LICENSES = 'GET_COMPANY_LICENSES'
export const GET_COMPANY_LICENSES_SUCCESS = 'GET_COMPANY_LICENSES_SUCCESS'
export const GET_COMPANY_LICENSES_FAILED = 'GET_COMPANY_LICENSES_FAILED'

export const GET_COMPANY_LICENSE = 'GET_COMPANY_LICENSE'
export const GET_COMPANY_LICENSE_SUCCESS = 'GET_COMPANY_LICENSE_SUCCESS'
export const GET_COMPANY_LICENSE_FAILED = 'GET_COMPANY_LICENSE_FAILED'

export const RESET_COMPANY_LICENSE_STATE = 'RESET_COMPANY_LICENSE_STATE'

export const FORM_CREATE_COMPANY_LICENSE = 'FORM_CREATE_COMPANY_LICENSE'

export const CREATE_COMPANY_LICENSE = 'CREATE_COMPANY_LICENSE'
export const CREATE_COMPANY_LICENSE_SUCCESS = 'CREATE_COMPANY_LICENSE_SUCCESS'
export const CREATE_COMPANY_LICENSE_FAILED = 'CREATE_COMPANY_LICENSE_FAILED'

export const DELETE_COMPANY_LICENSE = 'DELETE_COMPANY_LICENSE'
export const DELETE_COMPANY_LICENSE_SUCCESS = 'DELETE_COMPANY_LICENSE_SUCCESS'
export const DELETE_COMPANY_LICENSE_FAILED = 'DELETE_COMPANY_LICENSE_FAILED'

export const UPDATE_COMPANY_LICENSE = 'UPDATE_COMPANY_LICENSE'
export const UPDATE_COMPANY_LICENSE_SUCCESS = 'UPDATE_COMPANY_LICENSE_SUCCESS'
export const UPDATE_COMPANY_LICENSE_FAILED = 'UPDATE_COMPANY_LICENSE_FAILED'

export const GET_LICENSES = 'GET_LICENSES'
export const GET_LICENSES_SUCCESS = 'GET_LICENSES_SUCCESS'
export const GET_LICENSES_FAILED = 'GET_LICENSES_FAILED'

export const SEARCH_USER = 'SEARCH_USER'
export const SEARCH_USER_SUCCESS = 'SEARCH_USER_SUCCESS'
export const SEARCH_USER_FAILED = 'SEARCH_USER_FAILED'
